import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-case-page" }
const _hoisted_2 = { class: "edit-case-page__header" }
const _hoisted_3 = { class: "label-l edit-case-page__name" }
const _hoisted_4 = { class: "edit-case-page__content" }
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"11px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Debug info", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "MODEL-ACL", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "CASE-ITEM-ACL", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "VIDEOS-ACL", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "PARTICIPANT-ACL", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_CaseForm = _resolveComponent("CaseForm")!
  const _component_CaseVideos = _resolveComponent("CaseVideos")!
  const _component_CaseClusterPage = _resolveComponent("CaseClusterPage")!
  const _component_CaseParticipantsPage = _resolveComponent("CaseParticipantsPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            type: "secondary",
            icon: "close",
            round: "",
            class: "edit-case-page__close-button"
          }))
        : (_openBlock(), _createBlock(_component_NTabs, {
            key: 1,
            items: _ctx.tabItems,
            modelValue: _ctx.currentTab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentTab) = $event)),
            postfix: true
          }, {
            postfix: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$filters.shortString(_ctx.compItem.name)), 1)
            ]),
            _: 1
          }, 8, ["items", "modelValue"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.debug)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createTextVNode(": " + _toDisplayString(_ctx.maxAcl), 1),
            _hoisted_8,
            _hoisted_9,
            _createTextVNode(": " + _toDisplayString(_ctx.currentItemAcl) + " / EDIT " + _toDisplayString(_ctx.currentItemAclEdit), 1),
            _hoisted_10,
            _hoisted_11,
            _createTextVNode(": " + _toDisplayString(_ctx.relatedCaseVideosAcl), 1),
            _hoisted_12,
            _hoisted_13,
            _createTextVNode(": " + _toDisplayString(_ctx.relatedCaseParticipantsAcl), 1),
            _hoisted_14,
            _createTextVNode(" " + _toDisplayString(_ctx.compItem), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.TabNames.Info)
        ? (_openBlock(), _createBlock(_component_CaseForm, {
            key: 1,
            item: _ctx.compItem,
            disabled: !_ctx.currentItemAclEdit || _ctx.module.loading,
            onSave: _ctx.saveHandler,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, null, 8, ["item", "disabled", "onSave"]))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.TabNames.Sources)
        ? (_openBlock(), _createBlock(_component_CaseVideos, {
            key: 2,
            item: _ctx.compItem
          }, null, 8, ["item"]))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.TabNames.Clusters)
        ? (_openBlock(), _createBlock(_component_CaseClusterPage, {
            key: 3,
            item: _ctx.compItem,
            "participants-acl": _ctx.relatedCaseParticipantsAcl
          }, null, 8, ["item", "participants-acl"]))
        : _createCommentVNode("", true),
      (_ctx.currentTab === _ctx.TabNames.Participants)
        ? (_openBlock(), _createBlock(_component_CaseParticipantsPage, {
            key: 4,
            item: _ctx.compItem,
            "external-acl": _ctx.relatedCaseParticipantsAcl
          }, null, 8, ["item", "external-acl"]))
        : _createCommentVNode("", true)
    ])
  ]))
}